mainApp.directive('siteBandwidthManagement', function(){
    return {
        templateUrl: '/public/directives/siteBandwidthManagement.html',
        scope: {
            datamodified: "=",
            defaultTransport: "=",
            site: "=",
            orig: "="
        },
            controller: ['$scope', 'GeneralUtilsService', '$state', function($scope, GeneralUtilsService, $state){
            $scope.qosTableConfig = {
                noPaging:true,
                id: "qosPolicies",
                pageSize: 5,
                innerLoader:true,
                clientSideSort: true,
                fields: [
    		      { label: 'Priority',
    		        path:'priority',
    		        template: '<div ><span ng-if="item.priority != 255">P{{item.name}}</span><span ng-if="item.name == 255">Default</span></div>'},
//    		      { label: 'Override Account', path:'override', template: "<div class='checkbox form-checkbox'><label><input type='checkbox' ng-model='item.override'></label>&nbsp;</div>" },
    		      { label: 'Limits',
    		        path:'threshold',
    		        template: '<div ng-disabled="item.priority==255"> <select class="form-control" ng-model="item.bwLimitType" ng-options="bwLimitType.value as bwLimitType.key for bwLimitType in tableConfig.bwLimitTypeOptions"></select></div>', noSort: true },
    		      { label: ' ',
    		        path:'titles',
    		        template: "<div class='duplicate-value' ng-disabled=\"item.bwLimitType === 'NO_LIMIT'\"><span style='display:block;padding-bottom:10px;'>Upload: </span><span style='display:block;padding-top:10px;'> Download: </span></div>", noSort: true },
    		      { label: '',
    		        path:'limits',
    		        template: "<div class='duplicate-value' ng-disabled=\"item.bwLimitType === 'NO_LIMIT'\"><span><form-input path='qosPolicies.{{item.id}}.max.upload' class='limit-value'><input ng-model='item.maxUpload' type='number' class='limit-value'/></form-input><form-input path='qosPolicies.{{item.id}}.max.download' class='limit-value'><input ng-model='item.maxDownload' type='number' class='limit-value'/></form-input></span></div>", noSort: true },
    		      { label: '  ',
    		        path:'selections',
    		        template: "<div class='duplicate-value' ng-disabled=\"item.bwLimitType === 'NO_LIMIT'\"><select ng-model='item.uploadScale' class='form-control limit-scale upper' ng-options='scale.value as scale.name for scale in tableConfig.scales'></select><select ng-model='item.downloadScale' class='form-control limit-scale' ng-options='scale.value as scale.name for scale in tableConfig.scales'></select></div>", noSort: true },
    		      { label: 'Class Of Traffic',
    		        path:'classOfTraffic',
    		        template: "<div class='traffic ellipsis'><span>{{item.classOfTraffic}}</span></div>", noSort: true },
    		      { label: 'Account Default',
    		        path:'override',
    		        template: "<div class='duplicate-value' ng-show='item.override'><span style='display:block;padding-bottom:10px;'><b>U:&nbsp;</b>{{item.orig.maxUpload}}{{tableConfig.getScale(item.orig.uploadScale)}}</span><span style='display:block;padding-top:10px;'><b>D:&nbsp;</b>{{item.orig.maxDownload}}{{tableConfig.getScale(item.orig.downloadScale)}}</span></div>" },
    		      { label: 'Restore Account Defaults',
    		        path:'restore',
    		        template: "<button ng-show='item.override' type='submit' class='btn btn-save cato-btn btn-sm' ng-click='tableConfig.restore(item)'>Restore</button>" },
                ],
                scales: [
                    {
                        value: 'RELATIVE', name: '%',
                    },
                    {
                        value: 'ABSOLUTE', name: 'Mbps',
                    }
                ],
                 bwLimitTypeOptions: [
                    {   value: 'NO_LIMIT',
                        key: 'No limit'
                    },
                    {   value: 'ALWAYS_LIMIT',
                        key: 'Always limit'
                    },
                    {   value: 'LIMIT_WHEN_CONGESTED',
                        key: 'Limit only when line is congested'
                    }
                ],
                restore: function (item) {
                    item.override = false;
                    item.maxUpload = item.orig.maxUpload;
                    item.maxDownload = item.orig.maxDownload;
                    item.uploadScale = item.orig.uploadScale;
                    item.downloadScale = item.orig.downloadScale;
                    item.thresholdEnabled = item.orig.thresholdEnabled;
                    item.bwLimitType = item.orig.bwLimitType;

                },
                getScale: function(scale)
                {
                    var scaleItem = this.scales.filter(function(item){return item.value==scale;});
                    if (scaleItem && scaleItem[0]){
                        return scaleItem[0].name;
                    }
                    return "";

                },
                sortList: [{sortField: 'priority', sortDir: 'ASC'}],
                type: 'BandwidthManagementPolicy',
                hideCheckboxes: true,
                getLowestFree: function() {
                      var lowestQos = 0;
                      if (this.items) {
                          lowestQos = Math.max.apply(Math,this.items.map(function(o){return o.priority;}))
                      }
                      return lowestQos + 10;;

                  },
                selectedItems: [],
                removeConfirmation: function(items) {if (items.filter(function (qos) {return (qos.classOfTraffic && (qos.classOfTraffic.length > 0))}).length > 0) return "Items in use can not be deleted!"; return null;},
                noSearch: true,

                dataURL : function () {
                            if ($scope.site)
                                return '/bwManagement?siteId=' + $scope.site.id+ "&accountId="+$state.params.accountId +
                                        (this.defaultTransport === 'ALL_WAN' ? "&transport="+this.defaultTransport : "&interfaceId="+this.defaultTransport);
                                return null;
                                },
                actions : false,
                defaultTransport:$scope.defaultTransport.interface_id,
//                defaultTransport:$scope.defaultTransport === 'ALL_WAN' ? $scope.defaultTransport : $scope.defaultTransport.interface_id,
                parseData : function(data) {
                    var qosPolicies = [];
                    if (data) {
                        for (var policy in data.accountPolicies){
                            data.accountPolicies[policy].override = false;
                            if (data.sitePolicies[policy]) {
                                data.sitePolicies[policy].override = true;
                                data.sitePolicies[policy].orig = data.accountPolicies[policy];
                                data.sitePolicies[policy].classOfTraffic = data.accountPolicies[policy].classOfTraffic;
                                qosPolicies.push(data.sitePolicies[policy])
                            }
                            else {
                                qosPolicies.push(data.accountPolicies[policy])
                            }

                        }
                        qosPolicies.forEach(function(policy) {policy.priority = parseInt(policy.name);});
                        if (!$scope.orig.bwManagement)
                            $scope.orig.bwManagement ={};
                        $scope.orig.bwManagement[this.defaultTransport] = angular.copy(qosPolicies);
                        if (!$scope.site.bwManagement)
                            $scope.site.bwManagement ={};
                        $scope.site.bwManagement[this.defaultTransport] = qosPolicies;
                        return qosPolicies;
                    }
                    return [];
                }
            }
        }]
    };
});